import { Preferences } from "../../profile/objects/preferences";
import { PURCHASES_UNPAID_MODULE } from "../constant/purchasesReceiptConstant";
import { Column } from "../objects/column";

const subDomain = window.location.host.split('.')[0];

export const setPurchasesReceiptUnpaidPreference = (new_preferences: Preferences[], state_columns: Column[]): { order_by: string, order: 'asc' | 'desc', columns: Column[], preferences: Preferences[] } => {
    const field_name: string[] = [];
    const columns: Column[] = [];
    const preferences: Preferences[] = [];
    let order_by = '-created_date';
    let order: 'asc' | 'desc' = 'asc';
    new_preferences.map((preference: Preferences) => {
        if (preference.module === PURCHASES_UNPAID_MODULE) {
            if (!field_name.includes(preference.field_name)) {
                switch (preference.field_name) {
                    case 'STATUS':
                        columns.push({ label: 'state-column', field_name: preference.field_name, checked: preference.active, order_by: 'export_date', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'export_date' : order_by;
                        break;
                    case 'SOURCE':
                        columns.push({ label: 'source', field_name: preference.field_name, checked: preference.active, order_by: 'source', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'source' : order_by;
                        break;
                    case 'PROVIDER_INVOICE_NUMBER':
                        columns.push({ label: 'supplier-invoice-number', field_name: preference.field_name, checked: preference.active, order_by: 'provider_invoice_number', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'provider_invoice_number' : order_by;
                        break;
                    case 'PROVIDER':
                        columns.push({ label: 'provider', field_name: preference.field_name, checked: preference.active, order_by: 'provider', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'provider' : order_by;
                        break;
                    case 'INVOICE_DATE':
                        columns.push({ label: 'invoice-date', field_name: preference.field_name, checked: preference.active, order_by: 'invoice_date', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'invoice_date' : order_by;
                        break;
                    case 'TRIP_NUMBER':
                        if (subDomain !== "valeurs-assurances") {
                            columns.push({ label: 'folder', field_name: preference.field_name, checked: preference.active, order_by: 'trip_reference', fixed_width: false, last_updated: false });
                            order_by = preference.ordering_asc !== null ? 'trip_reference' : order_by;
                        }
                        break;
                    case 'REFERENCE':
                        if (subDomain === "valeurs-assurances") {
                            columns.push({ label: 'reference', field_name: preference.field_name, checked: preference.active, order_by: 'insurance_contract__reference', fixed_width: false, last_updated: false });
                            order_by = preference.ordering_asc !== null ? 'insurance_contract__reference' : order_by;
                        }
                        break;
                    case 'SUBSCRIPTION_METHOD':
                        if (subDomain === "valeurs-assurances") {
                            columns.push({ label: 'subscription-method', field_name: preference.field_name, checked: preference.active, order_by: 'insurance_contract__contracts_type__name', fixed_width: false, last_updated: false });
                            order_by = preference.ordering_asc !== null ? 'insurance_contract__contracts_type__name' : order_by;
                        }
                        break;
                    case 'INVOICE_NUMBER':
                        columns.push({ label: 'invoice-number', field_name: preference.field_name, checked: preference.active, order_by: 'invoice_number', fixed_width: true, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'invoice_number' : order_by;
                        break;
                    case 'TYPE':
                        columns.push({ label: 'type', field_name: preference.field_name, checked: preference.active, order_by: 'type', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'type' : order_by;
                        break;
                    case 'DEPARTURE_DATE':
                        columns.push({ label: 'departure-date', field_name: preference.field_name, checked: preference.active, order_by: 'product_start_date', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'product_start_date' : order_by;
                        break;
                    case 'DESCRIPTION':
                        columns.push({ label: 'description', field_name: preference.field_name, checked: preference.active, order_by: 'product_description', fixed_width: true, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'product_description' : order_by;
                        break;
                    case 'COLLECTION':
                        columns.push({ label: 'status', field_name: preference.field_name, checked: preference.active, order_by: 'is_paid', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'is_paid' : order_by;
                        break;
                    case 'AMOUNT':
                        columns.push({ label: 'amount', field_name: preference.field_name, checked: preference.active, order_by: 'amount', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'amount' : order_by;
                        break;
                    case 'BALANCE':
                        columns.push({ label: 'balance', field_name: preference.field_name, checked: preference.active, order_by: 'balance', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'balance' : order_by;
                        break;
                    case 'CREATED_DATE':
                        columns.push({ label: 'created-date', field_name: preference.field_name, checked: preference.active, order_by: 'created_date', fixed_width: true, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'created_date' : order_by;
                        break;
                    case 'CREATED_BY':
                        columns.push({ label: 'created-by', field_name: preference.field_name, checked: preference.active, order_by: 'creator__username', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'creator__username' : order_by;
                        break;
                    case 'MODIFIED_DATE':
                        columns.push({ label: 'modified-date', field_name: preference.field_name, checked: preference.active, order_by: 'modified_date', fixed_width: true, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'modified_date' : order_by;
                        break;
                    case 'MODIFIED_BY':
                        columns.push({ label: 'modified-by', field_name: preference.field_name, checked: preference.active, order_by: 'last_author__username', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'last_author__username' : order_by;
                        break;
                    default:
                        break;
                }
                preferences.push(preference);
                field_name.push(preference.field_name);
                order = preference.ordering_asc !== null ? preference.ordering_asc ? 'asc' : 'desc' : order;
            }
        }
    });
    if (columns.length !== state_columns.length) {
        state_columns.map(column => {
            let added = false;
            for (let i = 0; i < columns.length; i++) {
                if (columns[i].label === column.label) {
                    added = true;
                    break;
                }
            }
            if (!added) {
                columns.push({ ...column });
            }
        });
    }
    return { order_by, order, columns, preferences };
};